import { FC, useMemo } from "react";
import { useScript } from "../../app/hooks";
import { isProduction } from "../../helpers";

import { VviinnTag, VviinnWidgetProps, ApiPath } from "./types";

import { CDN_URL } from "./constants";

import "./styles.css";
import { TextSearchIcon, VPRIcon, VPSIcon } from "../icons";

export const ICONS_STYLES = "h-[22px] w-[22px] fill-stone-900 dark:fill-white";

export const VviinnWidget: FC<React.PropsWithChildren<VviinnWidgetProps>> = ({
  type,
  token,
  productId,
  classNames,
  children,
  customId,
  campaignId,
  showTextSearch,
  hideImageSearch,
}) => {
  useScript(`${CDN_URL}vviinn-widgets.esm.js`, "module");
  useScript(`${CDN_URL}vviinn-widgets.js`, "", true);

  const apiPath: ApiPath = isProduction
    ? "https://api.vviinn.com"
    : "https://api.stage.vviinn.com/";

  const generalVviinnTagProps: VviinnTag = {
    token,
    "api-path": apiPath,
    locale: "en-US",
  };

  const isVprButton = type === "vviinn-vpr-button";
  const isVpsButton = type === "vviinn-vps-button";

  const VpsWidgetIcon = useMemo(
    () =>
      showTextSearch ? (
        <TextSearchIcon className={ICONS_STYLES} />
      ) : (
        <VPSIcon className={ICONS_STYLES} />
      ),
    [showTextSearch],
  );

  return (
    <div
      className={
        classNames ??
        `${isVpsButton ? "h-8 w-8 mt-1" : "p-2 h-[22px] w-[22px]"} ${hideImageSearch ? " hide-image-search" : ""} flex items-center justify-center rounded-md bg-stone-200 transition-colors hover:bg-stone-100 focus:outline-none dark:bg-stone-500 dark:hover:bg-stone-600`
      }
      id={customId ?? "vviinn-widget-container"}
    >
      {isVprButton && productId && (
        <vviinn-vpr-button
          {...generalVviinnTagProps}
          product-id={productId}
          add-style="false"
          no-result-text="No results! Please check Campaigns menu and if there is not any campaign create new one."
        >
          <VPRIcon className={`scale-50 ${ICONS_STYLES}`} />
        </vviinn-vpr-button>
      )}

      {isVpsButton && (
        <vviinn-vps-button
          {...generalVviinnTagProps}
          campaign-id={campaignId}
          text-search-show={showTextSearch ? "true" : "false"}
        >
          {children ?? VpsWidgetIcon}
          {hideImageSearch && (
            <>
              <span slot="vviinn-image-upload-button-text">
                Visual Search campaigns only
              </span>
              <span slot="vviinn-camera-button-text-start">
                Visual Search campaigns only
              </span>
            </>
          )}
        </vviinn-vps-button>
      )}
    </div>
  );
};
